export const hashDataSHA256 = async (value: string) => {
  if (!value) return undefined;

  try {
    // Check if the environment supports Web Crypto
    if (!window.crypto || !window.crypto.subtle) {
      console.warn("Web Crypto API not supported in this context.");
      return undefined; // Or return null so you know tracking failed
    }

    const msgBuffer = new TextEncoder().encode(value.trim().toLowerCase());
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);

    return Array.from(new Uint8Array(hashBuffer))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  } catch (error) {
    console.error("Hashing failed:", error);
    return undefined;
  }
};
